// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__5ImQh","name":"Header_name__p8qY1","birthday":"Header_birthday__2j8uJ","skeleton":"Header_skeleton__3zR9r"};